import controller from './orders.controller';
import templateBase from './templates/orders-base.view.html';
import templateAD from './templates/orders.view-adaptative.html';

let OrdersComponent = {
    template:changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};


changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    //let response = SessionService.get('components');

    if(__env.adaptative) {
        return templateAD;
    } else {  
        return templateBase;
    }

}

export default OrdersComponent;



/** WEBPACK FOOTER **
 ** ./www/components/orders/orders.component.js
 **/